<template>
	<section class="events page">

    <photoswipe />

    <loading />

    <base-modal>
      <article class="modal-content">
        <header class="flex-center relative">
          <h4>{{ modalData.title }}</h4>
          <span class="absolute pointer"
                @click="close_modal">X</span>
        </header>
        <p>{{ modalData.content }}</p>
      </article>
    </base-modal>

    <ul>
      <li v-for="(item, index) in data"
          :key="index">
        <event-module :event="item" />
      </li>
    </ul>

    <div v-if="isAdmin"
         class="text-center"
         @click="addEvent">
      <button>ADD NEW EVENT</button>
    </div>
	</section>
</template>

<script>
  import Loading from '../components/Loading'
  import { EventModule, Photoswipe } from "../components"
  import { mapState } from 'vuex'
	export default {
		name: 'events',
    created () {
      // this.$store.dispatch('get_data_by_design', {url: 'textebune_events/_design/events/_view/all'})
      this.$store.commit('SET_STATE_KEY', {name: 'data', val: []})
    },
    mounted () {
      this.$store.dispatch('get_instagram')
    },
		computed: {
			...mapState({
        data: state => state.events,
        isAdmin: 'isAdmin',
        modalData: 'modalData'
      })
		},
		methods: {
      addEvent () {
        this.$store.dispatch('add_event')
      },
      close_modal () {
        this.$store.commit('SET_STATE_KEY', {name: 'isModal', val: false})
      }
		},
    components: {
      Photoswipe,
      EventModule,
      Loading
    }
	}
</script>

<style lang="less">
	.events {
    padding: 140px 0;
    & > ul > li {
      margin-bottom: 80px;
    }
    /*button {*/
      /*border-radius: 3px;*/
      /*padding: 10px 40px;*/
      /*margin-top: 24px;*/
      /*background-color: #50c607;*/
      /*font-size: 1.6rem;*/
      /*color: #fff;*/
      /*text-align: right;*/
      /*margin-left: auto;*/
    /*}*/
    .modal-content {
      width: 100%;
      height: 100%;
      max-width: 700px;
      max-height: 600px;
      background-color: white;
      padding-bottom: 40px;
      border-radius: 4px;
      header {
        border-bottom: 1px solid lightgrey;
        h4 {
          font-size: 2.2rem;
          max-width: 80%;
        }
        span {
          right: 22px;
          top: 22px;
          font-size: 3rem;
        }
      }
      p {
        padding: 18px;
        font-size: 2rem;
        overflow-y: scroll;
        height: 450px;
        line-height: 1.6;
      }
    }
	}
</style>
